export default "__VITE_ASSET__69c9f8ec__"